!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("dayjs")) : "function" == typeof define && define.amd ? define(["dayjs"], r) : e.dayjs_locale_fr = r(e.dayjs);
}(this, function (e) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e;
  var r = {
    name: "fr",
    weekdays: "Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi".split("_"),
    months: "Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre".split("_"),
    monthsShort: "janv_févr_mars_avril_mai_juin_juil_août_sept_oct_nov_déc".split("_"),
    weekStart: 1,
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "un an",
      yy: "%d ans"
    },
    ordinal: function ordinal(e) {
      return "" + e + (1 === e ? "er" : "");
    }
  };
  return e.locale(r, null, !0), r;
});